import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  className?: string;
  onClick?: () => void;
  variant?: 'primary' | 'secondary';
  href?: string;
}
export function CTAButton({
  text = 'Accedé ahora al Mega Pack',
  className = '',
  onClick,
  variant = 'primary',
  href
}: CTAButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-lg font-bold rounded-full transition-all duration-300 shadow-lg group';
  const variants = {
    primary: 'bg-gradient-to-r from-yellow-400 to-orange-400 text-white hover:from-yellow-500 hover:to-orange-500 hover:shadow-xl hover:-translate-y-1',
    secondary: 'bg-white text-orange-500 border-2 border-orange-100 hover:bg-orange-50 hover:border-orange-200 hover:-translate-y-1'
  };
  const content = <>
      <span data-id="element-11">{text}</span>
      <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-12" />
    </>;
  // Determinar si es un link interno (anchor) o externo
  const isInternalLink = href?.startsWith('#');
  if (href) {
    return <motion.a whileTap={{
      scale: 0.98
    }} href={href} target={isInternalLink ? undefined : '_blank'} rel={isInternalLink ? undefined : 'noopener noreferrer'} className={`${baseStyles} ${variants[variant]} ${className}`} onClick={onClick} data-id="element-13">
        {content}
      </motion.a>;
  }
  return <motion.button whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${className}`} onClick={onClick} data-id="element-14">
      {content}
    </motion.button>;
}